import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Brain, ChevronDown, Lock } from "lucide-react";
import "./MemoryInfluence.css";

// Actionable summary of which Parish Memory preferences shaped a generation.
export default function MemoryInfluence({ explain, subscribed }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  if (!subscribed || !explain) return null;

  const applied = (explain.resolved || []).filter((r) =>
    (r.source || "").toLowerCase().includes("memory"));
  const conflicts = explain.conflicts || [];
  if (applied.length === 0) return null;

  return (
    <div className="mi report-no-print" data-testid="memory-influence">
      <div className="mi-row">
        <div className="mi-lead">
          <span className="mi-eyebrow"><Brain size={15} /> Personalized by Your Parish Memory™</span>
          <p className="mi-text">
            This plan was informed by <b data-testid="mi-count">{applied.length}</b> established parish {applied.length === 1 ? "preference" : "preferences"}.
          </p>
        </div>
        <button className="mi-toggle" onClick={() => setOpen(!open)} data-testid="mi-toggle">
          View Details <ChevronDown size={15} className={open ? "up" : ""} />
        </button>
      </div>

      {open && (
        <div className="mi-detail" data-testid="mi-detail">
          <ul className="mi-list">
            {applied.map((m, i) => {
              const pct = Math.round((m.confidence || 0) * 100);
              const why = m.locked
                ? "Locked parish preference — always honored."
                : `Accepted parish preference observed across past plans (${pct}% confidence).`;
              return (
                <li key={i}>
                  <div className="mi-item-head">
                    {m.locked && <Lock size={13} className="mi-lock" />}
                    <b>{m.key.replace(/_/g, " ")}</b>
                    <span className="mi-val">{String(m.value)}</span>
                    <span className="mi-pct">{pct}%</span>
                  </div>
                  <div className="mi-why">{why}</div>
                </li>
              );
            })}
          </ul>

          {conflicts.length > 0 ? (
            <div className="mi-conflicts" data-testid="mi-conflicts">
              <span className="mi-conflicts-h">Conflicts resolved</span>
              <ul>
                {conflicts.map((c, i) => (
                  <li key={i}>Your current request overrode <b>{c.key.replace(/_/g, " ")}</b>{c.winner ? ` (used "${c.winner.value}").` : "."}</li>
                ))}
              </ul>
            </div>
          ) : (
            <p className="mi-noconflict" data-testid="mi-no-conflicts">No conflicts — every applied memory aligned with your request.</p>
          )}

          <p className="mi-foot">Full source reports & history live in Parish Memory™.</p>
          <button className="mi-manage" onClick={() => navigate("/parish-memory")} data-testid="mi-manage">
            Manage Parish Memory™
          </button>
        </div>
      )}
    </div>
  );
}
